import styled from 'styled-components';
 /* istanbul ignore next */
const StyledValidationMessage = styled.div.attrs(() => ({
  className: '',
}))`
  display: flex;
  align-items: flex-start;
  ${(props) => props.customStyles || ''};
  & > img {
    width: 14px;
    margin-right: 4px;
  }
  & > p {
    color: #cc284e;
    font-size: 14px;
    line-height: 1rem;
  }
`;

export default StyledValidationMessage;
